import { Subscription } from "../types/Subscription";
import { ProductType } from "../types/subscriptions/ProductType";
import { constants } from "../api/constants";

export const getSubscriptionIdToProductTypeMap = (
	subscriptions: Subscription[] | null | undefined,
	forDowngrade: boolean = false
): Map<string, ProductType> => {
	const map = new Map<string, ProductType>();
	if (subscriptions && Array.isArray(subscriptions)) {
		for (const subscription of subscriptions) {
			if (subscription.seats > 0) {
				// For downgrade, exclude Primary subscriptions with exactly 2 seats (minimum required)
				if (forDowngrade && subscription.productType === ProductType.Primary && subscription.seats === 2) {
					continue;
				}
				map.set(subscription.id, subscription.productType);
			}
		}
	}
	return map;
};

export const isNewSubscription = (subscription: Subscription | null | undefined): boolean => {
	return subscription !== null && subscription !== undefined && subscription.accountType === constants.SUBSCRIPTION_ACCOUNT_TYPE.NEW;
};

// For new subscriptions the subscription's own countdown is the source of truth — the org-level
// trialDaysRemaining can be stale/negative for trial-extended orgs (LSP-15991). Falls back to the
// org value for legacy subscriptions and for orgs with no subscription trial date.
export const effectiveTrialDaysRemaining = (
	subscription: Subscription | null | undefined,
	orgTrialDaysRemaining: number | null | undefined
): number | null | undefined => {
	if (isNewSubscription(subscription) && subscription?.trialDaysRemaining != null) {
		return subscription.trialDaysRemaining;
	}

	return orgTrialDaysRemaining;
};

export const hasLuckyProductSubscription = (subscriptions: Subscription[] | null | undefined): boolean => {
	if (!subscriptions || !Array.isArray(subscriptions)) {
		return false;
	}

	const luckyProductType = "addon_lucky";
	const contactProductCode = "contact";

	return subscriptions.some((subscription) => {
		const productType = String(subscription?.productType || "").trim().toLowerCase();
		const productCode = String(subscription?.productCode || "").trim().toLowerCase();
		return productType === luckyProductType && productCode === contactProductCode;
	});
};
